import React from "react";
import logo from "../../assets/logo.png";
import "./AboutMe.css";

export const AboutMe = () => {
  return (
    <section className="section" id="about">
      <h1 className="sectionTitle">
        <span style={{ color: "aqua" }}>I. </span>About Me
      </h1>

      <div className="d-flex flex-row align-items-center justify-content-between">
        <div className="w-50 my-4">
          <p className="pTag">
            Hello, My Name is{" "}
            <span style={{ color: "aqua" }}>Piyush Kesarwani</span> and I love
            to create and build things that live on the Internet. I started my
            career on web development by learning HTML and CSS and I get very
            fond of it. Then, I keep learning new languages, JS libraries as I
            knew more about them. I love to create interesting projects,
            contributing to open-source, and learning new technologies. My main
            focus these days is{" "}
            <span style={{ color: "aqua" }}>
              building accessible, inclusive products and digital experiences
            </span>{" "}
            for variety of clients.
          </p>
          <p className="pTag">
            I also write technical blogs/articles related to my learning and
            knowledge in Web development. Besides, I also make interesting
            Youtube videos on my YouTube channel and I enjoy listening to music.
          </p>
          <p className="pTag">
            Here are a few technologies I’ve been working with recently:
            <ol>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <div className="w-25 mt-3 me-3">
                  <li>JavaScript(ES6+)</li>
                  <li>ReactJs</li>
                  <li>NodeJs</li>
                </div>
                <div className="mt-3 w-50 ms-4">
                  <li>Express</li>
                  <li>C/C++ (Data Structure and Algorithms)</li>
                  <li>Python</li>
                </div>
              </div>
            </ol>
          </p>
        </div>
        <div className="w-50 m-5">
          <img className="aboutImage ms-5" src={logo} alt="Piyush Kesarwani" />
        </div>
      </div>
    </section>
  );
};
